import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrent } from '../redux/settings/selectors';
// import { selectCurrentTheme, selectIsDarkMode } from './themeSelectors'; // Adjust the path as necessary
// import { toggleDarkMode } from './themeActions'; // If you implement a toggle action

const ThemeProvider: React.FC<any> = ({ children }) => {
  const currentTheme = useSelector(selectCurrent);
  // console.log('currentTheme', currentTheme, selectCurrentDynamicTheme)
  // const isDarkMode = useSelector(selectIsDarkMode);
  const dispatch = useDispatch();

  useEffect(() => {
    document.documentElement.className = ''; // Clear existing theme classes
    document.documentElement.classList.add(`theme-${currentTheme.theme}`);    
  }, [currentTheme]);

  // useEffect(() => {
  //   document.documentElement.className = ''; // Clear existing theme classes
  //   document.documentElement.classList.add(`theme-${currentTheme}`);
  //   if (isDarkMode) {
  //     document.documentElement.classList.add('dark');
  //   }
  // }, [currentTheme, isDarkMode]);

  return <>{children}</>;
};

export default ThemeProvider;
